import React from 'react';
import { Amount } from '@razorpay/blade/components';

export const ClickableAmount = ({
  value,
  onAmountClick,
}: {
  value: number;
  onAmountClick?: () => void;
}) => {
  return onAmountClick ? (
    <a onClick={onAmountClick} role="button" tabIndex={0}>
      <Amount
        color="interactive.text.primary.normal"
        value={value}
        suffix="decimals"
        size="large"
        weight="semibold"
      />
    </a>
  ) : (
    <Amount value={value} suffix="decimals" size="large" weight="semibold" />
  );
};
